module.exports = __webpack_public_path__ + "static/media/img_18.3d73cfa3.png";